import gsap from "gsap";

export default function Hero() {
  Alpine.data("hero", () => ({
    init() {
      const mm = gsap.matchMedia();
      mm.add("(min-width: 1024px)", () => {
        if (this.$refs.media) {
          gsap.to(this.$refs.text, {
            opacity: 0,
            ease: "none",
            scrollTrigger: {
              trigger: this.$el,
              start: "bottom bottom",
              end: "bottom 80%",
              scrub: true,
              debug: true,
            },
          });

          gsap.to(this.$refs.mediachild, {
            yPercent: 20,
            ease: "none",
            scrollTrigger: {
              trigger: this.$el,
              start: "bottom bottom",
              end: "bottom top",
              scrub: true,
              debug: true,
            },
          });

          gsap.fromTo(
            this.$refs.media,
            {
              clipPath: "polygon(30% 30%, 70% 30%, 70% 70%, 30% 70%)",
            },
            {
              clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
              ease: "none",
              scrollTrigger: {
                trigger: this.$root,
                start: "top top",
                end: "bottom bottom",
                scrub: true,
              },
            },
          );
        }

        // if (this.$refs.text) {
        //   gsap.fromTo(
        //     this.$refs.text,
        //     {
        //       clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
        //     },
        //     {
        //       clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
        //       ease: "none",
        //       scrollTrigger: {
        //         trigger: this.$el,
        //         start: "top top",
        //         end: "top top-=150svh",
        //         scrub: true,
        //       },
        //     },
        //   );
        // }
      });

      // if (this.$refs.media) {
      //   gsap.to(this.$refs.media, {
      //     yPercent: 25,
      //     ease: "none",
      //     scrollTrigger: {
      //       trigger: this.$el,
      //       start: "top top",
      //       end: "bottom top",
      //       scrub: true,
      //     },
      //   });
      // }
      // if (this.$refs.headline) {
      //   gsap.fromTo(
      //     this.$refs.headline,
      //     {
      //       opacity: 0,
      //     },
      //     {
      //       opacity: 1,
      //       duration: 0.85,
      //       delay: 0.25,
      //       ease: "sine.out",
      //     },
      //   );
      // }
    },
  }));
}
